export const getImage = (state, key) => state.assets.getIn(["images", key]);
export const getImages = (state, key) => state.assets.get("images");
export const getToken = (state) => state.assets.get("authenticity_token");

export const getCountries = (state) => state.assets.get("countries");
